import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { RoomInfoProducts, RoomProduct } from "@b2bportal/lodging-api";
import {
  HotelRoomCardDialog,
  HotelRoomCardRates,
  ImageCarousel,
  useHotelRoomCard,
  useHotelRoomCardTracking,
} from "@tenant/hotels";
import { Icon, useControlledDialog } from "@tenant/ui";
import clsx from "clsx";
import { ImageGallery } from "../ImageGallery";
import defaultStyles from "./HotelRoomCard.module.scss";

export interface HotelRoomCardComponentProps extends PlatformComponentProps {
  room: RoomInfoProducts;
  onRoomSelection: (product: RoomProduct) => void;
  nightCount: number;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelRoomCard;

export const HotelRoomCard = (props: HotelRoomCardComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, room } = props;
  const { context, handlers, text } = useHotelRoomCard(props);
  const { ref } = useHotelRoomCardTracking(props);
  const gridDialogControl = useControlledDialog();

  return (
    <div className={clsx(block, className)} ref={ref}>
      <div className={cn("image")}>
        <ImageCarousel
          imageUrlsArray={context.images}
          onClick={gridDialogControl.openDialog}
        />
      </div>
      <div className={cn("content")}>
        <div className={cn("room-name")}>{text.roomName}</div>
        <div className={cn("room-details")}>
          <div className={cn("room-info")}>
            {text.guests != null ? (
              <div className={cn("guest")}>
                <Icon iconName={IconNameEnum.guest} />
                {text.guests}
              </div>
            ) : null}
            <div className={cn("bed")}>
              <Icon iconName={IconNameEnum.bed} />
              {text.beds}
            </div>
          </div>
          <HotelRoomCardDialog
            className={cn("view-details")}
            room={context.room}
            nightCount={context.nightCount}
          />
        </div>

        <div className={cn("divider")} />
        <HotelRoomCardRates
          room={context.room}
          products={context.products}
          setSelectedProduct={handlers.setSelectedProduct}
          selectedProduct={context.selectedProduct}
          nightCount={context.nightCount}
        />
      </div>
      <button
        className={cn("room-select-button")}
        onClick={() => handlers.onRoomSelection(context.selectedProduct)}
      >
        {text.roomCTA}
      </button>
      <ImageGallery
        media={room.roomInfo.media}
        name={room.roomInfo.name}
        onClickChooseRooms={gridDialogControl.closeDialog}
        externalDialogControl={gridDialogControl}
        hideExternalTriggers
        hideTitle
        hideChooseRoomButton
      />
    </div>
  );
};
